<!-- 项目信息 -->
<template>
  <div class="project">
    <h1 class="application-title">项目信息</h1>
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate">
      <div class="project-form">
        <div class="dis-96"
             v-for="(item, index) in formValidate.projectMessage"
             :key="index">
          <zlr-card-shink :title="'目标项目 '+(index+1)">
            <div class="w720 dis-30">
              <div>
                <div class="delete"
                     v-if="index!=0"
                     @click="removeProjectMessage(index)"></div>
                <FormItem label="学校名称（英文填写）"
                          prop="name"
                          :label-width="226">
                  <Input v-model="item.univerName"
                         placeholder="e.g. Harvard University"></Input>
                </FormItem>
              </div>
              <FormItem label="项目名称（英文填写）"
                        prop="name"
                        :label-width="226">
                <Input v-model="item.projrctName"
                       placeholder="e.g. PhD in Statistics"></Input>
              </FormItem>
              <FormItem label="想去程度排序，1最高，10最低"
                        prop="name"
                        :label-width="226">
                <Select v-model="item.purposeLevel">
                  <Option :value="item"
                          v-for="item in 10"
                          :key="item">{{item}}</Option>
                </Select>
              </FormItem>
            </div>
            <div class="dis-26 label-bot-20">
              <FormItem label='去年招收中国学生情况（大概招了多少人，何种背景等）'
                        prop="name">
                <Input v-model="item.qnqk"
                       placeholder="Please limit your response to 50 words"
                       type="textarea"
                       :rows="6"> </Input>
              </FormItem>
            </div>
            <div class="dis-30 label-bot-20">
              <FormItem label='学长学姐申请的情况（请详细介绍，比如跟你同系，同实验室）'
                        prop="name">
                <Input v-model="item.xzxjqk"
                       placeholder="Please limit your response to 50 words"
                       type="textarea"
                       :rows="6"> </Input>
              </FormItem>
            </div>
          </zlr-card-shink>
        </div>
        <div class="application-order-add"
             @click="addProjectMessage">添加更多 目标项目</div>
        <div class="sub-btn" v-if="isallowedit">
          <Affix :offset-bottom="20">
            <Button type="primary"
                    style="width:96px;"
                    @click="saveHandle">保存</Button>
          </Affix>
        </div>
      </div>
    </Form>

  </div>
</template>

<script>
import isAllowEdit from '@/view/mixins/is-edit'
//  api
import { infoQueryItem, infoModifyItem } from '@/api/info'
// components
import ZlrCardShink from '_c/card-shrink/card-shrink'
export default {
  name: 'application-project',
  mixins: [isAllowEdit],
  components: {
    ZlrCardShink
  },
  data () {
    return {
      formValidate: {},
      ruleValidate: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      infoQueryItem().then(res => {
        let data = res.data.model || {}

        this.formValidate = Object.assign({}, data)

        this.$set(this.formValidate, 'projectMessage', data.projectMessage || [{}])
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    saveHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          infoModifyItem(data).then(res => {
            this.$zlr_message('保存成功', 'success')
            this.$router.push({
              name: 'application-research-direction'
            })
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          })
        }
      })
    },
    addProjectMessage () {
      this.formValidate.projectMessage.push({
        name: '',
        description: ''
      })
    },
    removeProjectMessage (index) {
      this.formValidate.projectMessage.splice(index, 1)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
